module.exports = __webpack_public_path__ + "media/audio4.d6f68300.mp3";